<template>
  <v-list-item two-line dense>
    <v-list-item-content>
      <v-list-item-title>{{ titulo }}</v-list-item-title>

      <v-list-item-subtitle :title="conTitle ? subtitulo : ''">
        {{ subtitulo }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    subtitulo: {
      type: [String, Number],
      default: null,
    },
    conTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>